// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"37b26253","387":"5fe54f96","411":"ff79639b","772":"155ee8f7","787":"1bfd4ebb","804":"85c92802"}[chunkId] + ".chunk.js";
};